import { APP_INITIALIZER, ErrorHandler, Injectable, NgModule } from '@angular/core';
import { HttpClientModule, HttpClientXsrfModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule, HammerGestureConfig, HammerModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import * as Hammer from 'hammerjs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AppRoutingModule, routes } from './app-routing.module';
import { LayoutModule } from './layout/layout.module';

import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import { TokenInterceptor } from './shared/interceptor/auth.interceptor';
import { LaunchdarklyService } from '@acesso-io/launchdarkly-client-ts/lib/launchdarkly';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import * as Sentry from "@sentry/angular-ivy";
import { TraceModule } from '@sentry/angular-ivy';
import { TraceService } from '@sentry/angular-ivy';

@Injectable()
export class HammerConfig extends HammerGestureConfig {
  overrides = <any> {
    swipe: { direction: Hammer.DIRECTION_ALL },
  };
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    TraceModule,
    HttpClientModule,
    BrowserModule,
    RouterModule,
    HammerModule,
    LayoutModule,
    AppRoutingModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    BrowserAnimationsModule,
    FontAwesomeModule,
    HttpClientXsrfModule.withOptions({
      headerName: 'Acesso-Csrf-Token',
    }),
  ],
  providers: [
    TokenInterceptor,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfig
    },
    {
      provide: LaunchdarklyService,
      useFactory: () => new LaunchdarklyService(environment.launchDarklyClientId)
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [TraceService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (ld: LaunchdarklyService) => async() => {
        await ld.init({})
      },
      multi: true,
      deps: [LaunchdarklyService],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
